var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreencancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16194 11.3301C0.845537 11.6465 0.83047 12.2115 1.16948 12.543C1.50095 12.8745 2.06596 12.867 2.38237 12.5505L6.99286 7.93252L11.6109 12.5505C11.9348 12.8745 12.4923 12.8745 12.8238 12.543C13.1477 12.204 13.1552 11.6541 12.8238 11.3301L8.21328 6.7121L12.8238 2.10161C13.1552 1.77767 13.1552 1.22019 12.8238 0.888715C12.4848 0.564775 11.9348 0.557242 11.6109 0.881181L6.99286 5.49921L2.38237 0.881181C2.06596 0.564775 1.49342 0.549708 1.16948 0.888715C0.838003 1.22019 0.845537 1.7852 1.16194 2.10161L5.77997 6.7121L1.16194 11.3301Z",
    fill: "#20996B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencancel);
export default __webpack_public_path__ + "static/media/greencancel.a5319405d383fe38afd57d2f8f59a4d2.svg";
export { ForwardRef as ReactComponent };